import * as XLSX from 'xlsx';

export interface ExcelParseResult {
  headers: string[];
  rows: Record<string, string>[];
  sheetName: string;
}

export async function parseExcel(file: File): Promise<ExcelParseResult> {
  const arrayBuffer = await file.arrayBuffer();
  const workbook = XLSX.read(arrayBuffer, { type: 'array' });
  
  // Take the first sheet
  const sheetName = workbook.SheetNames[0];
  const worksheet = workbook.Sheets[sheetName];
  
  // Convert to JSON with first row as headers
  const jsonData = XLSX.utils.sheet_to_json<any[]>(worksheet, {
    header: 1,
    defval: '',
    raw: false,
  });
  
  if (jsonData.length === 0) {
    return { headers: [], rows: [], sheetName };
  }
  
  // First row = headers
  // Handle Excel formula errors like #NAME? which often represent "NOM" column
  const headers = (jsonData[0] as string[]).map(h => {
    const str = String(h || '').trim();
    // Keep #NAME? as is - it will be mapped to lastName in detectColumnMapping
    return str;
  }).filter(h => h !== '');
  
  // Rest = data rows
  const rows = jsonData.slice(1)
    .filter((row: any[]) => row.some(cell => cell !== '')) // Skip empty rows
    .map((row: any[]) => {
      const record: Record<string, string> = {};
      headers.forEach((header, index) => {
        record[header] = String(row[index] || '').trim();
      });
      return record;
    });
  
  return { headers, rows, sheetName };
}

export function isExcelFile(file: File): boolean {
  const excelTypes = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
  ];
  return excelTypes.includes(file.type) || 
         file.name.endsWith('.xlsx') || 
         file.name.endsWith('.xls');
}
